/**
 * Kamuni Wholesale Button Handler
 * Maneja la lógica de mostrar/ocultar botones de WhatsApp vs compra normal
 */

(function() {
  'use strict';

  /**
   * Actualiza la interfaz basado en el contexto de wholesale
   */
  function updateWholesaleInterface(isWholesale) {

    
    // Elementos del producto
    const buyButtons = document.querySelector('.product-form__buttons');
    const quantitySelector = document.querySelector('#Quantity-Form-template--17808266084646__main');
    const variantPicker = document.querySelector('.product-variant-picker');
    const priceElement = document.querySelector('#price-template--17808266084646__main');
    const productForm = document.querySelector('.product-form');
    
    if (!buyButtons) return;

    if (isWholesale) {
      // Modo wholesale - mostrar WhatsApp y ocultar todo lo demás
      showWhatsAppButton(buyButtons);
      hideRetailElements(quantitySelector, variantPicker, priceElement, productForm);
    } else {
      // Modo retail - mostrar botones normales
      showRetailButtons(buyButtons);
      showRetailElements(quantitySelector, variantPicker, priceElement, productForm);
    }
  }

  /**
   * Muestra el botón de WhatsApp
   */
  function showWhatsAppButton(container) {
    // Verificar si ya existe el botón de WhatsApp
    if (container.querySelector('.kamuni-whatsapp-button')) return;

    // Ocultar botones existentes
    const existingButtons = container.querySelectorAll('button, .shopify-payment-button');
    existingButtons.forEach(btn => btn.style.display = 'none');

    // Crear botón de WhatsApp
    const whatsappButton = createWhatsAppButton();
    if (!whatsappButton) {
      console.error('Kamuni: No se pudo crear el botón de WhatsApp');
      return;
    }
    container.appendChild(whatsappButton);

    // Agregar mensaje explicativo mejorado
    const message = document.createElement('div');
    message.className = 'kamuni-wholesale-message';
    message.setAttribute('data-wholesale-message', 'true');
    message.innerHTML = `
      <h4 style="margin: 0 0 0.5rem 0; font-size: 1.1rem; font-weight: 600;">
        🏭 Producto para Distribución
      </h4>
      <p style="margin: 0; font-size: 0.95rem; line-height: 1.4;">
        Este producto está disponible exclusivamente para distribuidores.<br>
        <strong>Contáctanos</strong> para información sobre precios mayoristas, cantidades mínimas y condiciones especiales.
      </p>
    `;
    container.appendChild(message);

    // Agregar clase al body para activar estilos CSS
    document.body.classList.add('kamuni-wholesale-context');
  }

  /**
   * Crea el botón de WhatsApp
   */
  function createWhatsAppButton() {
    const productTitle = document.querySelector('.product__title h1')?.textContent?.trim() || 'producto';
    const productUrl = window.location.href;
    
    // Obtener el número de WhatsApp desde settings (inyectado por Liquid en el DOM)
    const settingsElement = document.querySelector('[data-kamuni-settings]');
    const whatsappNumber = settingsElement?.dataset?.whatsappNumber || '';
    
    // Si no hay número configurado, no mostrar el botón
    if (!whatsappNumber) {
      console.error('Kamuni: No se encontró número de WhatsApp en settings');
      return null;
    }

    const message = `Hola! 👋

Estoy interesado en el producto "${productTitle}" para distribución.

🔗 Link del producto: ${productUrl}

¿Podrían proporcionarme información sobre:
• Precios mayoristas
• Cantidades mínimas de pedido
• Condiciones de distribución
• Disponibilidad y tiempos de entrega

¡Gracias!`;

        const cleanNumber = whatsappNumber.replace(/\+/g, '').replace(/\s/g, '').replace(/-/g, '').replace(/\(/g, '').replace(/\)/g, '').replace(/\./g, '');
        const whatsappUrl = `https://wa.me/${cleanNumber}?text=${encodeURIComponent(message)}`;

    const button = document.createElement('a');
    button.href = whatsappUrl;
    button.target = '_blank';
    button.className = 'product-form__submit kamuni-whatsapp-button';
    button.style.cssText = `
      background: #25D366 !important;
      color: white !important;
      text-decoration: none !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 0.5rem !important;
    `;

    button.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.515"/>
      </svg>
      Contactar por WhatsApp
    `;

    return button;
  }

  /**
   * Muestra los botones de retail normales
   */
  function showRetailButtons(container) {
    // Ocultar botón de WhatsApp si existe
    const whatsappButton = container.querySelector('.kamuni-whatsapp-button');
    if (whatsappButton) {
      whatsappButton.style.display = 'none';
    }

    // Remover mensaje wholesale si existe
    const wholesaleMessage = container.querySelector('.kamuni-wholesale-message');
    if (wholesaleMessage) {
      wholesaleMessage.remove();
    }

    // Mostrar botones originales
    const originalButtons = container.querySelectorAll('button:not(.kamuni-whatsapp-button), .shopify-payment-button');
    originalButtons.forEach(btn => btn.style.display = '');

    // Remover clase del body
    document.body.classList.remove('kamuni-wholesale-context');
  }

  /**
   * Oculta elementos de retail (cantidad, variantes, precios)
   */
  function hideRetailElements(quantitySelector, variantPicker, priceElement, productForm) {
    // Ocultar selector de cantidad
    if (quantitySelector) {
      quantitySelector.style.display = 'none';
    }
    
    // Ocultar selector de variantes
    if (variantPicker) {
      variantPicker.style.display = 'none';
    }
    
    // Ocultar precios
    if (priceElement) {
      priceElement.style.display = 'none';
    }
    
    // Ocultar todo el formulario de producto (incluye variantes y cantidad)
    const formInputs = document.querySelectorAll('.product-form__input');
    formInputs.forEach(input => {
      if (!input.closest('.product-form__buttons')) {
        input.style.display = 'none';
      }
    });
    
    // Ocultar elementos adicionales de e-commerce
    const installmentForm = document.querySelector('.installment');
    if (installmentForm) {
      installmentForm.style.display = 'none';
    }
    
    const taxInfo = document.querySelectorAll('.product__tax');
    taxInfo.forEach(tax => {
      if (!tax.textContent.includes('distribución')) {
        tax.style.display = 'none';
      }
    });
    
    const volumePricing = document.querySelector('.volume-pricing-note');
    if (volumePricing) {
      volumePricing.style.display = 'none';
    }
  }

  /**
   * Muestra elementos de retail (cantidad, variantes, precios)
   */
  function showRetailElements(quantitySelector, variantPicker, priceElement, productForm) {
    // Mostrar selector de cantidad
    if (quantitySelector) {
      quantitySelector.style.display = '';
    }
    
    // Mostrar selector de variantes
    if (variantPicker) {
      variantPicker.style.display = '';
    }
    
    // Mostrar precios
    if (priceElement) {
      priceElement.style.display = '';
    }
    
    // Mostrar todo el formulario de producto
    const formInputs = document.querySelectorAll('.product-form__input');
    formInputs.forEach(input => {
      input.style.display = '';
    });
    
    // Mostrar elementos adicionales de e-commerce
    const installmentForm = document.querySelector('.installment');
    if (installmentForm) {
      installmentForm.style.display = '';
    }
    
    const taxInfo = document.querySelectorAll('.product__tax');
    taxInfo.forEach(tax => {
      if (!tax.textContent.includes('distribución')) {
        tax.style.display = '';
      }
    });
    
    const volumePricing = document.querySelector('.volume-pricing-note');
    if (volumePricing) {
      volumePricing.style.display = '';
    }
  }

  /**
   * Determina si debe ser wholesale basado en tag + contexto
   */
  function determineWholesaleStatus() {
    // 1. Verificar si el producto tiene el tag de materia prima
    const debugInfo = document.querySelector('[data-kamuni-debug]');
    const isRawMaterial = debugInfo && debugInfo.textContent.includes('is_raw_material = true');
    
    if (!isRawMaterial) {
      return false;
    }

    // 2. Si es materia prima, verificar contexto de navegación primero
    const navigationContext = window.KamuniCollectionContext?.get();
    if (navigationContext && navigationContext.isWholesale) {
    
      return true;
    }

    // 3. Fallback: verificar lo que determinó el servidor (Liquid)
    const isWholesale = debugInfo && debugInfo.textContent.includes('is_wholesale = true');
    
    if (isWholesale) {
      return true;
    }

    return false;
  }

  /**
   * Inicializar el handler
   */
  function init() {
    const isWholesale = determineWholesaleStatus();
    updateWholesaleInterface(isWholesale);
  }

  // Escuchar evento de contexto
  document.addEventListener('kamuniCollectionContext', function(event) {
    updateWholesaleInterface(event.detail.isWholesale);
  });

  // Inicializar cuando esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Exponer para debugging
  window.KamuniWholesale = {
    update: updateWholesaleInterface,
    determine: determineWholesaleStatus,
    init: init
  };

})();
